import { useMemo } from "react";
import { COLORS, getEmployeeName, REPLIES } from "../AnnouncementReplies";

const createChartData = () => [
  [
    "Lloji",
    "Numri i pergjigjeve",
    { role: "style" },
    {
      sourceColumn: 0,
      role: "annotation",
      type: "string",
      calc: "stringify",
    },
  ],
  ["Konfirmoi", 0, COLORS.confirm, null],
  ["Anashkaloi", 0, COLORS.skip, null],
  ["Refuzoi", 0, COLORS.refuse, null],
];

const useAnnouncementData = (announcement, employees, filterBy) => {
  return useMemo(() => {
    if (!announcement || !employees?.length) {
      return { responses: [], departments: [], chartData: createChartData() };
    }

    const { usersResponses, groupedResponses } = announcement;
    const responses = [];
    const departments = new Set();
    const chartData = createChartData();
    const repliesKeys = Object.keys(REPLIES);

    const processEmployee = (employeeId, response, updatedAt) => {
      const employee = employees.find((e) => e.employeeId === employeeId);
      if (!employee) return;

      departments.add(employee.employeeDepartmentName);

      responses.push({
        response,
        updatedAt,
        employeeId,
        employeeName: getEmployeeName(employee),
        announcementId: announcement.announcementId,
        employeeDepartmentName: employee.employeeDepartmentName,
      });

      const chartIndex = repliesKeys.indexOf(response);
      if (chartIndex !== -1) {
        chartData[chartIndex + 1][1] += 1;
      }
    };

    if (filterBy && groupedResponses?.[filterBy]) {
      Object.entries(groupedResponses[filterBy]).forEach(
        ([employeeId, updatedAt]) => {
          processEmployee(employeeId, filterBy, updatedAt);
        }
      );
    } else if (usersResponses) {
      Object.entries(usersResponses).forEach(
        ([employeeId, { response = "No response", updatedAt }]) => {
          processEmployee(employeeId, response, updatedAt);
        }
      );
    }

    return {
      responses,
      chartData,
      departments: Array.from(departments),
    };
  }, [announcement, employees, filterBy]);
};

export default useAnnouncementData;
